import React, { FC } from 'react'

interface Props {
  size?: number
}

export const WattpadIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#FF6122"
    />
    <path
      d="M16 0.213867C24.7182 0.213867 31.7861 7.28179 31.7861 16C31.7861 24.7182 24.7182 31.7861 16 31.7861C7.28179 31.7861 0.213867 24.7182 0.213867 16C0.213867 7.28179 7.28179 0.213867 16 0.213867Z"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="0.428571"
    />
    <path
      d="M19.7431 14.761C20.525 13.6866 21.889 11.936 23.3463 11.3255C24.5462 10.8222 25.7978 11.3503 25.4448 12.7354C25.3062 13.2781 24.6133 14.017 24.129 14.7398C23.2945 15.9857 22.4426 17.5677 21.7482 18.9996C21.2631 20.0003 20.9116 20.8376 20.2135 21.4744C18.4994 23.039 15.9144 21.6524 16.1099 17.8828C15.1493 19.0864 14.5891 21.721 13.3528 22.9471C12.894 23.4022 11.8531 23.907 10.8473 23.6364C8.17184 22.9172 7.69481 18.1177 8.1536 14.5517C8.34325 13.0695 8.84507 11.6683 9.84508 11.2941C10.5759 11.0206 11.6051 11.2168 12.0377 11.6078C12.9144 12.3992 12.6781 14.1366 12.6642 15.4605C13.1259 14.8463 13.7532 13.656 14.5432 12.7354C15.2551 11.9061 16.177 10.9207 17.1121 10.7303C19.3988 10.265 20.0757 12.4298 19.7431 14.761Z"
      fill="white"
    />
  </svg>
)
